/**
 * Creates a cropped image blob from the original image and crop area.
 * @param {string} imageSrc - The source URL of the image (object URL or data URL)
 * @param {Object} pixelCrop - The crop area { x, y, width, height } in pixels
 * @param {string} outputType - MIME type for output (default: 'image/jpeg')
 * @returns {Promise<Blob>} The cropped image as a Blob
 */
export default function getCroppedImg(imageSrc, pixelCrop, outputType = 'image/jpeg') {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute('crossOrigin', 'anonymous');

    image.addEventListener('load', () => {
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Canvas toBlob failed'));
            return;
          }
          resolve(blob);
        },
        outputType,
        0.9
      );
    });

    image.addEventListener('error', () => reject(new Error('Image load failed')));
    image.src = imageSrc;
  });
}
